// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__Ik6O0","banner_icon":"Banner_banner_icon__N2j0k"};